var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2664 7.78109C42.3204 7.57481 41.7802 7.00755 39.1871 6.38872C37.5664 5.61518 35.7837 4.37752 35.1354 2.98514C34.4871 1.59277 30.9216 0.045696 28.8147 1.74748C26.7078 3.44927 25.8975 4.84163 27.032 11.4941C27.032 17.373 25.2504 18.197 23.9538 18.8674C22.6033 17.6297 18.0869 16.8562 10.8263 23.6633C3.56564 30.4705 3.37116 32.688 4.1815 32.9458C3.4792 33.4615 1.88013 34.4929 1.1022 34.4929C0.129793 34.4929 0.615998 36.3494 2.23668 36.5041C3.85736 36.6588 3.85736 38.8247 11.6366 34.8023C13.4518 35.5449 16.4987 35.7305 17.4711 35.7305C17.7412 36.5556 18.4759 38.5153 19.2538 39.7529C19.9021 41.2381 19.74 41.0937 19.578 40.8359H25.4124C25.3044 40.6296 24.6021 40.1242 22.6573 39.7529C20.7124 39.3816 20.6584 36.9166 20.8745 35.7305C23.8998 35.4727 30.1448 33.4718 33.5158 27.531C37.7296 20.105 31.894 11.9582 32.0561 10.1017C32.2181 8.24521 34.0009 6.69814 36.7561 7.47167C39.5112 8.24521 41.9422 8.70934 42.2664 7.78109Z",
    stroke: "#03422F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0283 16C27.8111 16.4935 28.9345 16.9468 30.6629 17.1382M33.9365 17.1382C33.0143 17.4566 31.5921 17.2411 30.6629 17.1382M24.2022 19.7398V34.3333M30.6629 17.1382C29.9302 21.1692 26.1311 30.6476 12.8219 30.1667M11.022 24.3333C12.0163 25.7425 13.3167 28.2195 12.6886 34.3333",
    stroke: "#03422F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuck);
export default __webpack_public_path__ + "static/media/duck.3fcfd3edc210f70911cac3f716049412.svg";
export { ForwardRef as ReactComponent };